import * as React from "react";
import FormSectionActionsBar from "./FormSectionActionsBar";
import QualifierActionsBar from "./QualifierActionsBar";
import AttributeActionBox from "./AttributeActionBox";
import { Button, Icon } from "antd";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {}

export interface Props {
  translate: any;
  selectedFormElement?: any;
  UpdateSectionForm: any;
  onUpdateSection: any;
  UpdateQualifierForm: any;
  updateFormConfigSectionQualifier(
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): any;
  UpdateAttributeForm: any;
  updateFormConfigQualifierAttribute(
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  showAddQualifierModal: any;
  createSection: any;
  showRemoveSectionModal: any;
  showRemoveQualifierModal: any;
  showAddAttributeModal: any;
  showInvalidateAttributeModal: any;
  hideFormParamsBox: any;
  readOnly: boolean;
}

export default class FormParamsBox extends React.Component<Props, State> {
  render() {
    const {
      selectedFormElement,
      translate,
      UpdateSectionForm,
      onUpdateSection,
      UpdateQualifierForm,
      updateFormConfigSectionQualifier,
      UpdateAttributeForm,
      updateFormConfigQualifierAttribute,
      showAddQualifierModal,
      createSection,
      showRemoveSectionModal,
      showRemoveQualifierModal,
      showAddAttributeModal,
      showInvalidateAttributeModal,
      hideFormParamsBox,
      readOnly
    } = this.props;
    if (!selectedFormElement) {
      return null;
    }
    return (
      <div className={"form-property-editor"}>
        <Button style={{ float: "right" }} onClick={(e) => hideFormParamsBox()}>
          <Icon type="close" />
        </Button>
        {selectedFormElement && selectedFormElement.formTypeCode && (
          <div>
            <h2>{translate("main_form.segment_title")}</h2>
            <UpdateSectionForm
              readOnly={readOnly}
              section={selectedFormElement}
              translate={translate}
              Actions={
                <FormSectionActionsBar
                  translate={translate}
                  onAddQualifierBtnClick={showAddQualifierModal}
                  onCreateBtnClick={() => createSection(selectedFormElement)}
                  onRemoveBtnClick={showRemoveSectionModal}
                />
              }
              updateFormSection={onUpdateSection}
            ></UpdateSectionForm>
          </div>
        )}
        {selectedFormElement.qualifier && selectedFormElement.qualifier.code && (
          <div>
            <h2>{translate("main_form.qualifier_title")}</h2>

            <UpdateQualifierForm
              formConfigSectionQualifier={selectedFormElement}
              translate={translate}
              updateFormConfigSectionQualifier={
                updateFormConfigSectionQualifier
              }
              readOnly={readOnly}
              Actions={
                <QualifierActionsBar
                  translate={translate}
                  onRemoveBtnClick={showRemoveQualifierModal}
                  addAttributeBtnClick={showAddAttributeModal}
                ></QualifierActionsBar>
              }
            ></UpdateQualifierForm>
          </div>
        )}
        {selectedFormElement.attribute && selectedFormElement.attribute.code && (
          <div>
            <h2>{translate("main_form.attribute_title")}</h2>

            <UpdateAttributeForm
              readOnly={readOnly}
              Actions={
                <AttributeActionBox
                  translate={translate}
                  onRemoveBtnClick={showInvalidateAttributeModal}
                ></AttributeActionBox>
              }
              formConfigQualifierAttribute={selectedFormElement}
              translate={translate}
              updateFormConfigQualifierAttribute={
                updateFormConfigQualifierAttribute
              }
            ></UpdateAttributeForm>
          </div>
        )}
      </div>
    );
  }
}
